<div class="cursor-pointer" [ngClass]="{ 'pointer-events-none': isWorkflow }">
  <finxone-web-frontend-payment-cancellation
    [isUsingHtmlStructure]="pageConfig.isUsingHtmlStructure ?? true"
    [contentStyle]="contentStyle"
    [selectedTextStyleClass]="selectedTextStyleClass"
    [colorTextAlignStyle]="colorTextAlignStyle"
    [renderedContent]="renderedContent"
    [remainingSeconds]="remainingSeconds"
    (actionClick)="onActionClick()"
  ></finxone-web-frontend-payment-cancellation>
</div>
